const locale = {
  'productList.filter.title': 'Фильтр',
  'productList.filter.reset': 'Сброс',
  'productList.filter.manufacturer': 'Производитель',
  'productList.filter.manufacturer.placeholder': 'выберите производителя',
  'productList.filter.years': 'Годы',
  'productList.filter.years.start.placeholder': 'начальный год',
  'productList.filter.years.end.placeholder': 'конечный год',
  'productList.filter.models': 'Модель автомобиля',
  'productList.filter.models.placeholder': 'выберите модель',
  'productList.filter.bodycode': 'Кузов',
  'productList.filter.bodycode.placeholder': 'выберите кузов',
  'productList.filter.enginecode': 'Двигатель',
  'productList.filter.enginecode.placeholder': 'выберите двигатель',
  'productList.filter.catalogs': 'Каталоги',
  'productList.filter.catalogs.placeholder': 'выберите каталоги',

  'productList.message.addToListSuccessfully': 'Успешно добавлено в список',
  'productList.message.removingListSuccessfully': 'Успешно удалено из списка',
  'productList.message.addToListFailed': 'Не удалось добавить в список',
  'productList.message.removingListFailed': 'Не удалось удалить из списка',

  'productList.loginGuidance.oeAndPrice':
    'После входа вы сможете просмотреть оставшиеся {total} OE элементов и цены',
  'productList.loginGuidance.price': 'После входа вы сможете просмотреть цены',

  'productList.old': 'старый',
  'productList.old.tips':
    'Этот номер является старым и больше не используется производителем автомобилей',
  'productList.replaceNum': 'Номер замены',
  'productList.replaceNum.OE': 'Номер OE',
  'productList.replaceNum.circulationRating': 'Рейтинг обращения',
  'productList.replaceNum.price.OEM': 'Цена OEM',
  'productList.replaceNum.price.aftermarket': 'Цена aftermarket',
  'productList.replaceNum.suspensionDate': 'Дата приостановки',
  'productList.replaceNum.suspensionDate.tips':
    'Дата, когда производитель автомобилей прекратил использование этого номера. Если дата пуста, это означает, что производитель все еще использует этот номер',
};

export default locale;
